import { Organization, OrganizationRef } from '../../models';
import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const createJointNominee: (
  fetchContext: FetchContext,
  nominationId: number,
  organization: Organization,
  accessToken?: string,
) => Promise<OrganizationRef> = (fetchContext, nominationId, organization, accessToken) =>
  fetch(`${fetchContext.baseUrl}/api/nominations/${nominationId}/joint-nominees`, {
    method: 'POST',
    body: JSON.stringify(organization),
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  })
  .then((response) => responseErrorHandler<OrganizationRef>(fetchContext.errorStore, response, 'create joint nominee'));
